import { render, staticRenderFns } from "./ParticipatingTheJudgesSwiper.vue?vue&type=template&id=24db5e5b&"
import script from "./ParticipatingTheJudgesSwiper.vue?vue&type=script&lang=js&"
export * from "./ParticipatingTheJudgesSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ParticipatingTheJudgesSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports